import React, { useEffect } from "react";
import LoadingLoginScreen from "../../../components/LoadingLoginScreen";


import { useLocation } from "react-router-dom";

import { Alert, Button, Container, Dropdown, Form } from "react-bootstrap";
import { AddServiceHelper } from "./AddServiceHelper";
import { AdminAddService, getAllCompanies } from "../../../services/AdminService";


export const AddServices = ({ company }) => {

    const location = useLocation();
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    const [errorType, setErrorType] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [addServicesModal, setShowAddServicesModal] = React.useState(false);
    const [companies, setCompanies] = React.useState([]);
    const [companyReference, setCompanyReference] = React.useState('');
    const serviceRef = React.useRef('');
    const qrRef = React.useRef('');

    let timer;

    useEffect(() => {
        if (location.pathname === `/leadtub-admin-company/${company}`) {
            setCompanyReference(company)
        } else {
            const getCompanies = async () => {
                setCompanies(await getAllCompanies());
            }
            getCompanies().then(() => {
                setError(true);
                setErrorType("success")
                setErrorText("Alla företag inladdade")

                timer = setTimeout(() => {
                    setError(false);
                }, 5000);

            });
        }


    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {

            if (!serviceRef.current.value) {
                setError(true);
                setErrorText("Ange en tjänst")
                setErrorType("warning")
                return;
            } else if (companyReference === "" || undefined) {
                setError(true);
                setErrorText("Ange ett företag")
                setErrorType("warning")
                return;
            } else if (!qrRef.current.value) {
                setError(true);
                setErrorText("Ange QR-kod")
                setErrorType("warning")
                return;
            } else {
                try {
                    setLoading(true)
                    await AdminAddService(companyReference, serviceRef.current.value, qrRef.current.value).then(() => {
                        setError(true);
                        setErrorType("success")
                        setErrorText(`Tjänst tillagt hos ${companyReference}`)
                    })
                    setLoading(false);
                } catch (e) {
                    console.error(e)
                }

            }
        } catch (e) {

            setError(true);
            setErrorText("Fyll i fälten")
        }

    }

    return (
        <>
            {loading ? <LoadingLoginScreen /> :
                <Form

                    style={{ padding: "30px", margin: " 30px" }}
                >
                    <Container>
                        {error ? <Alert variant={`${errorType}`}>
                            {errorText}
                        </Alert> : null}
                        {companies <= 0 ?

                            <p>{company}</p> :

                            <Dropdown>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    Välj Företag
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {companies.map((company) =>
                                        <Dropdown.Item
                                            key={company.id}
                                            eventKey={company.id}
                                            onSelect={function (evt) {
                                                setCompanyReference(evt)
                                            }}
                                        >{company.companyName}</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>


                        }
                        {companyReference ? (
                            <span>Valt {companyReference}</span>
                        ) :
                            (
                                <span>Inget företag valt</span>
                            )}


                        {companyReference ? (
                            <React.Fragment>
                                <Form.Group id={"amount"}>
                                    <Form.Label>Namn på tjänsten som {companyReference} erbjuder ?</Form.Label>
                                    <Form.Control type={"text"} ref={serviceRef} placeholder={"Golvslipning"} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Ange QR-Kod</Form.Label>
                                    <Form.Control
                                        type={"text"}
                                        ref={qrRef}
                                        placeholder={"haga-tak/takarbete"} />
                                </Form.Group>
                            </React.Fragment>
                        )
                            : (
                                <Alert variant={"secondary"}>
                                    Välj ett företag
                                </Alert>)}

                        <Button variant="primary" disabled={loading} onClick={handleSubmit}>
                            Skapa tjänst
                        </Button>
                        {companyReference ?
                            <AddServiceHelper company={companyReference} />
                            : null}
                    </Container>
                </Form>

            }

        </>
    )
}
